export default __webpack_public_path__ + "static/media/picto-edit.d42f71f2.svg";